
export default class Navigation {

	constructor() {
		this.settings = {
			body: document.querySelector('body'),
			el: document.querySelector('[data-block="main-menu"]'),
			hamburger: document.querySelector('[data-toggle="hamburger-desktop"]')
		};

		this.bindUIActions();
	}

	bindUIActions() {

		const headerStyles = () => {
			let headerHeight = $('.js-header').height();
			$('.main').css('padding-top', headerHeight + 'px');
			$('.js-search-reveal').css('top', headerHeight + 'px');
		};

		$(document).ready(() => {
			headerStyles();
		});

		$(window).on("resize", () => {
			headerStyles();
		});

		if (this.settings.hamburger != null) {
			this.settings.hamburger.addEventListener('click', () => {
				this.settings.body.classList.toggle('overflow-hidden');
				this.settings.el.classList.toggle('open');
				this.settings.hamburger.classList.toggle('active');
			});
		}

		let $navLevel1 = $('a[data-nav-level-1]');
		let $navLevel2 = $('a[data-nav-level-2]');

		let $navLevel1Array = $navLevel1.toArray();
		let $navLevel2Array = $navLevel2.toArray();

		$navLevel1Array.forEach((navItem) => {

			let navItemVal = navItem.getAttribute('data-nav-level-1');

			navItem.addEventListener('mouseover', function () {

				let $menuLinks = $('.menu-link');

				let $menuLinksArray = $menuLinks.toArray();
				$menuLinksArray.forEach((link) => {
					link.classList.remove('active');
				});

				navItem.classList.add('active');

				let $navLevel2 = $('ul[data-nav-level-1-child]');
				let $navLevel3 = $('ul[data-nav-level-2-child]');

				let $navLevel2Array = $navLevel2.toArray();
				let $navLevel3Array = $navLevel3.toArray();
				

					$navLevel2Array.forEach((navLvl2) => {

						if (navLvl2.getAttribute('data-nav-level-1-child') === navItemVal) {
							const threeLayers = navLvl2.querySelector('[data-nav-level-2]');

							if(threeLayers) {

								if(navLvl2.classList.contains('nav-3-layers')) {
									navLvl2.classList.remove('hidden');
								}

							} else {
								if(navLvl2.classList.contains('nav-2-layers')) {

									if(navLvl2.previousElementSibling.classList.contains('nav-3-layers') && (!navLvl2.previousElementSibling.classList.contains('hidden')) ) {
										navLvl2.classList.add('hidden');
									} else {
										navLvl2.classList.remove('hidden');
									}

									$navLevel3Array.forEach((layer3) => {
										layer3.classList.add('hidden');
									});

								}
							}

						}
						else {
							navLvl2.classList.add('hidden');
						}
					});

			});

		});

		$navLevel2Array.forEach((navItem2) => {

			let navItem2Val = navItem2.getAttribute('data-nav-level-2');

			navItem2.addEventListener('mouseover', function () {
				let $navLevel3 = $('ul[data-nav-level-2-child]');

				let $navLevel3Array = $navLevel3.toArray();

				$navLevel3Array.forEach((navLvl3) => {
					if (navLvl3.getAttribute('data-nav-level-2-child') === navItem2Val) {
						navLvl3.classList.remove('hidden');
					} else {
						navLvl3.classList.add('hidden');
					}

				});

			});

		});

		//Mobile Menu

		let $navLevel1Mobile = $('a[data-nav-level-1-mobile]');
		let $navLevel2Mobile = $('a[data-nav-level-2-mobile]');

		let $navLevel1ArrayMobile = $navLevel1Mobile.toArray();
		let $navLevel2ArrayMobile = $navLevel2Mobile.toArray();

		$navLevel1ArrayMobile.forEach((navItem) => {

			let navItemVal = navItem.getAttribute('data-nav-level-1-mobile');

			navItem.addEventListener('click', function () {
				let $navLevel2 = $('ul[data-nav-level-1-child-mobile]');
				let $navLevel2Array = $navLevel2.toArray();
				
				navItem.classList.toggle('active');

				$navLevel2Array.forEach((navLvl2) => {
					if (navLvl2.getAttribute('data-nav-level-1-child-mobile') === navItemVal) {
						navLvl2.classList.toggle('max-h-0');
						navLvl2.classList.toggle('overflow-hidden');
					}
				});

			});

		});

		$navLevel2ArrayMobile.forEach((navItem2) => {

			let navItem2Val = navItem2.getAttribute('data-nav-level-2-mobile');

			navItem2.addEventListener('click', function () {
				let $navLevel3 = $('ul[data-nav-level-2-child-mobile]');

				let $navLevel3Array = $navLevel3.toArray();

				$navLevel3Array.forEach((navLvl3) => {
					if (navLvl3.getAttribute('data-nav-level-2-child-mobile') === navItem2Val) {
						navLvl3.classList.toggle('max-h-0');
						navLvl3.classList.toggle('overflow-hidden');
					}

				});

			});

		});

	}
};

new Navigation();